var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHooks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#F0B429"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11030_28669)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5176 20.0839L23.7894 18.5074L23.7847 18.5039C24.7906 17.3615 26.24 16.7062 27.7588 16.7062H29.9918L28.0553 14.7698L28.8871 13.938L32.2435 17.2945L28.8859 20.6521L28.0541 19.8203L29.9918 17.8827H27.7588C26.5953 17.8827 25.4871 18.3827 24.7059 19.2462L23.4353 20.8215L22.5176 20.0839ZM18.8835 24.5839L18.8706 24.5745C18.0859 25.5545 16.9141 26.118 15.6553 26.118H12V27.2945H15.6553C17.2659 27.2945 18.7671 26.5756 19.7765 25.3227L19.7894 25.3333L20.8965 23.9615L19.9823 23.2215L18.8835 24.5839ZM28.0541 24.1815L29.9918 26.118H27.7588C26.5212 26.118 25.3694 25.5662 24.5823 24.6109L19.56 18.4168L19.5482 18.4262C18.5482 17.3368 17.1388 16.7062 15.6553 16.7062H12V17.8827H15.6553C16.8294 17.8827 17.9471 18.3862 18.7271 19.2592L23.6223 25.2968L23.6165 25.3015C24.6282 26.5674 26.1376 27.2945 27.7576 27.2945H29.9906L28.0541 29.2309L28.8859 30.0627L32.2435 26.705L28.8859 23.3474L28.0541 24.1815Z",
    fill: "#010E20"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11030_28669"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHooks);
export default __webpack_public_path__ + "static/media/hooks.0cd2c66200a0eb939e5fe1e6c3fef9bd.svg";
export { ForwardRef as ReactComponent };